/**
 * 업무 글에 검색어가 드는가. 공백을 지우고 견준다 — 「자재 발주」 로 적힌 글이 「자재발주」 로도 걸리고,
 * 그 반대도 된다(대화의 업무 조회 {@code DirectoryMapper.searchByDuty} 와 같은 규칙).
 *
 * 직원찾기 목록(담당업무·전결표 업무로 걸렀는가)과 명함의 전결표 모달(어느 줄을 칠할까)이 같이 쓴다 —
 * 두 벌이면 목록에서는 걸렸는데 모달에서는 아무 줄도 안 칠해지는 날이 온다.
 */
export function matchesDuties(duties: string | null | undefined, keyword: string): boolean {
  if (!duties) return false;
  const needle = keyword.replace(/\s+/g, '').toLowerCase();
  return needle !== '' && duties.replace(/\s+/g, '').toLowerCase().includes(needle);
}
